<template>
    <custom-modal :title="form.form_type_def ? form.form_type_def.label : 'Form'" v-model="show" @close="close()" :loading="loading" :width="form.id && form.status != 'initial' ? 1050 : 800">
        <v-row>
            <v-col cols="12" :md="form.id && form.status != 'initial' ? 8 : 12">
                <FormBlocks
                    v-if="form.id"
                    v-model="form.form_sections"
                    :filled.sync="blocksFilled"
                    :item-id="form.id"
                    :disabled="!form.editable"
                    model="StaffForm"
                    ref="formBlocks"
                />
            </v-col>

            <v-col cols="12" md="4" v-if="form.id && form.status != 'initial'">
                <ApprovalStages 
                    model="StaffForm" 
                    :refID="form.id"
                    dir="rtl"
                    class="dhivehi" 
                />
                <ActivityLog model="StaffForm" :ref_id="form.id" />
            </v-col>
        </v-row>

        <template #actions>
            <v-btn 
                outlined color="success" small 
                @click="update('save')" 
                v-if="form.id && form.status == 'initial'"
                :disabled="!blocksFilled"
            >
                save
            </v-btn>

            <v-btn 
                outlined color="success" small 
                @click="update('submit')" 
                v-if="form.id && form.status == 'draft'"
                :disabled="!blocksFilled"
            >
                submit
            </v-btn>
            <v-btn 
                outlined color="blue" small 
                @click="update('update')" 
                v-if="form.id && form.status == 'draft'"
                :disabled="!blocksFilled"
            >
                update
            </v-btn>
        </template>
    </custom-modal>
</template>

<script>
import CustomModal from '../util/CustomModal.vue'
import ActivityLog from '../user-activity/ActivityLog.vue'
import FormBlocks from '../form-blocks/Blocks.vue'
import ApprovalStages from '@/components/approval-components/approvalStages.vue'
import axios from '../../plugins/axios'

export default {
    components: {CustomModal, ActivityLog, FormBlocks, ApprovalStages},
    data: () => ({
        loading: false,
        form: {editable: true},
        blocksFilled: false,
        show: false,
    }),
    methods: {
        getItem() {
            this.loading = true
            axios.get(`/api/staff-forms/${this.form.id}/get`).then((resp) => {
                this.form = resp.data
            }).finally(() => this.loading = false)
        },
        edit(id) {
            this.form.id = id
            this.getItem()
            this.show = true
        },
        async update(update_type) {
            this.loading = true
            try {
                let data = {...this.form}
                data[update_type] = update_type

                await this.$refs.formBlocks?.save()

                let resp = await axios.put(`/api/staff-forms/${this.form.id}/update`, data)
                this.form = resp.data.data
            } finally {
                this.loading = false
            }
        },
        open(form_type) {
            this.loading = true
            axios.get(`/api/staff-forms/${form_type}/getInitialData`).then((resp) => {
                this.form = resp.data
                this.show = true
            }).finally(() => this.loading = false)
        },
        close() {
            if (this.form.status == 'initial') axios.delete(`/api/staff-forms/${this.form.id}/delete`)

            this.$emit('reload')
            this.resetData()
        },
        resetData() {
            Object.assign(this.$data, this.$options.data())
        },
    },
}
</script>

<style>

</style>